<script>
/**
 * ****************************************************************************
 * @description     :   Checkbox component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input checkbox component
 */
var AnsCheckbox = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: Array,
        isSwitch: {
            type: Boolean,
            default: false
        },
        modelValue: Array,
        isDisabled: Boolean,
        options: Array,
        optionsDisabled: Array,
        onChange: Function
    },
    emits: ['update:modelValue'],
    computed: {
        vewValue() {
            return this.modelValue ? this.modelValue : this.value;
        }
    },
    methods: {
        /**
         * disabled item for input checkbox component
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : id
         * @access : private
         */
        disabledOption(id) {
            if (this.isDisabled) {
                return true;
            }
            const idx = _.indexOf(this.optionsDisabled, id, 0);
            if (idx > -1) {
                return true;
            }
            return false;
        },
        /**
         * selected item for input checkbox component
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            const idx = _.findIndex(this.vewValue, function (o) {
                return o == val;
            });
            if (idx < 0) {
                return false;
            } else {
                return true;
            }
        },
        /**
         * updated input checkbox component
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : id
         * @access : private
         */
        updateInput(e) {
            const val = e.target.value;
            const idx = _.indexOf(this.vewValue, val, 0);
            if (idx < 0) {
                this.vewValue.push(val);
            } else {
                this.vewValue.splice(idx, 1);
            }
            this.$emit('update:modelValue', this.vewValue);
            if (this.onChange) {
                this.onChange(e, this.vewValue);
            }
        }
    }
};
export default AnsCheckbox;
</script>
